import React, { useEffect, useRef, useState } from "react";
import { Input, Checkbox } from "element-react";
import TableView from "components/tableView";
import { GetReviewersWithAssignedInfo } from "store/actions/articles";
import RoleEnum from "constants/roleEnum";
import Popover from "components/popup/_popover";

const ReviewerPopup = (props) => {
  const {
    popRef,
    setOpen,
    open,
    dispatch,
    name,
    onChange,
    row,
    selectedReviewer,
  } = props;
  const [state, setState] = useState({ name: "" });
  const [selected, setSelected] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [value, setValue] = useState([]);
  useEffect(() => {
    setValue(selectedReviewer);
  }, [selectedReviewer]);

  useEffect(() => {
    fetchData("");
  }, []);

  const fetchData = async (fullname) => {
    var res: any = await dispatch(
      GetReviewersWithAssignedInfo({
        articleId: row.Id,
        fullname: fullname,
      })
    );

    setTableData(res);
  };
  const onSelected = (row) => {
    const { AssignedAndNotStarted } = row;
    if (AssignedAndNotStarted) return;
    const newValue = [...value];
    const index = newValue.findIndex((x) => x.Id === row.Id);
    if (index >= 0) newValue.splice(index, 1);
    else newValue.push(row);
    onChange && onChange(name, newValue);
  };
  const isChecked = (row) =>
    value && value.filter((x) => x.Id === row.Id).length > 0;

  const columns = [
    {
      label: "",
      prop: "",
      width: 60,
      render: (row, column, index) => {
        return (
          <div>
            <Checkbox
              disabled={row.AssignedAndNotStarted}
              checked={isChecked(row)}
              onChange={() => onSelected(row)}
            />
          </div>
        );
      },
    },
    {
      label: "Reviewer",
      prop: "FullName",
      render: (row, column, index) => (
        <div onClick={() => onSelected(row)}>{row.FullName}</div>
      ),
    },

    {
      label: "Total",
      prop: "TotalReviewAssigned",
      width: 80,
      render: (row, column, index) => (
        <div onClick={() => onSelected(row)}>{row.TotalReviewAssigned}</div>
      ),
    },
    {
      label: "InReview",
      prop: "UnderReview",
      width: 120,
      render: (row, column, index) => (
        <div onClick={() => onSelected(row)}>{row.UnderReview}</div>
      ),
    },
    {
      label: "Completed",
      prop: "Completed",
      width: 120,
      render: (row, column, index) => (
        <div onClick={() => onSelected(row)}>{row.Completed}</div>
      ),
    },
    {
      label: "Declined",
      prop: "Declined",
      width: 100,
      render: (row, column, index) => (
        <div onClick={() => onSelected(row)}>{row.Declined}</div>
      ),
    },
  ];

  const onChangeName = (val) => {
    setState({ ...state, name: val });
    fetchData(val);
  };
  return (
    <Popover
      parentRef={popRef}
      open={open}
      handleOutsideClick={() => setOpen(!open)}
    >
      <div className="assign-popup">
        <div className="margin-bottom-10">
          <Input
            value={state.name}
            placeholder="Search Reviewer"
            onChange={(val: any) => onChangeName(val)}
          ></Input>
        </div>
        <div className="margin-bottom-10">
          <TableView showNoData={false} columns={columns} data={tableData} />
        </div>
      </div>
    </Popover>
  );
};
export default ReviewerPopup;
